export class TotalCharge {
  charge: number = 0;
  effect_date: Date = new Date(0);
  end_date?: Date = new Date(0);
}